import React from "react";
import HeroBGSrc from "../assets/img/cancer/01B2F015.jpg";
import HeroBGSrcTablet from "../assets/img/cancer/01B2F015.jpg";
import HeroBGSrcMobile from "../assets/img/cancer/01B2F015.jpg";
import {
  getPhoneClaims,
} from "../helpers/ContentStateHelper";
import { Paths } from "../constants/UrlConstants";
import { Link } from "react-router-dom";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const Check4CancerProstate = {
  HeroBGSrc: HeroBGSrc,
  HeroBGSrcTablet: HeroBGSrcTablet,
  HeroBGSrcMobile: HeroBGSrcMobile,
  Heading:
    "Have you got raised PSA levels?",
  Description: (
    <React.Fragment>
      <p>
      Find out about the prostate diagnostic service we offer with Check4Cancer
      </p>
      
    </React.Fragment>
  ),
  c4cServiceAccess : "Who can access this service?",
  ServiceDescription: {
    Any: (state) => (
      <React.Fragment>
        If you have cover for outpatient specialist consultations and diagnostic tests, you can use this service. You can find this in your 
        {" "} <Link style={{ fontSize: "16px" }}
           className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
           >
             membership documents  
           </Link>. If it’s appropriate, we’ll offer you an appointment with our diagnostic service provider Check4Cancer and explain how this may impact your outpatient limits and excess if you have one on your plan.​
           <p></p>

           If you’re on a company scheme, you can check to see if your employer has selected the diagnostic cancer service with Check4Cancer by referring to your 
            {" "} <Link style={{ fontSize: "16px" }}
             className={"hol-link " + layoutStyle.anchorDecorationUnderline}
             to={Paths.Cover}
           >
             handbook
           </Link>. If your company hasn’t chosen this option, you will need to see your GP to get a referral before you can use this service. Once you have a referral, call us on {<strong>{getPhoneClaims(state)}</strong>}  we’ll be happy to help.
      </React.Fragment>
    )
  },
  ServiceDescriptionIndSME : (
    <p>
    If you have cover for outpatient specialist consultations and diagnostic tests, you can use this service. You can find this in your {" "}<Link style={{ fontSize: "16px" }}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
          >
            membership documents 
          </Link>. If it’s appropriate, we’ll offer you an appointment with our diagnostic service provider Check4Cancer and explain how this may impact your outpatient limits, NCD and or excess if you have one on your plan.
    </p>
  ),
  c4cProcessHeader: "How does it work?",
  discussWithYourGPDetail: (
    <React.Fragment>
      <h3>You’ve received confirmation your PSA levels are raised</h3>
      <p>
      If you’re aged 40 and over with confirmation that you've a raised PSA level, for example, through a check-up with your GP or as a result of a health screening, you may need to see a specialist for further investigation.
      </p>
    </React.Fragment>
  ),
  callUsDetail: {
    Any: (state) => (
    <React.Fragment>
      <h3>Call Us</h3>
      <p>
      Call us on {<strong>{getPhoneClaims(state)}</strong>} and we’ll ask you a few questions to understand what is causing your concern. If appropriate we’ll offer you an appointment with Check4Cancer for an initial clinical assessment.
</p> <p>
We can normally offer you an appointment within <strong>5 working days</strong> of your call. And we’ll give you a choice of the location and date of your appointment, so you can attend when’s easiest for you.
      </p>
    </React.Fragment>
  )
},
  check4CancerDetail: (
    <React.Fragment>
      <h3>Check4Cancer</h3>
      <p>
      The Check4Cancer clinical team will then guide you through the next steps. They’ll book either a multi-parametric MRI scan or a consultation, to help you get a diagnosis as quickly as possible.
      </p>
      <p><strong> Check4Cancer Opening hours: Monday – Friday 8am to 6pm </strong></p>
    </React.Fragment>
  ),
};

export default Check4CancerProstate;
